import React from 'react';

const Register = () => {
    return (
        <div>
            This is Register
        </div>
    );
};

export default Register;